import React from "react";

export interface CTAWorkWithUsProps {
    header?: string;
    title?: string;
    imageUrl?: string;
    content?: string;
}


const DEFAULT_HEADER = "Ready to Transform Your Educational Environment?";
const DEFAULT_TITLE = "Your Vision";
const DEFAULT_IMAGE_URL = "https://hncnzwww.blob.core.windows.net/www/img/NewWebPhotos/Homepage/hnc-web-homepage-your-business.jpg";
const DEFAULT_CONTENT = "Partner with us for industry-leading resources, unmatched support, and years of expertise.<br>Let’s turn your project vision into reality, from appliances to furniture and decor.";

const CTAWorkWithUs: React.FC<CTAWorkWithUsProps> = ({
    header = DEFAULT_HEADER,
    title = DEFAULT_TITLE,
    imageUrl = DEFAULT_IMAGE_URL,
    content = DEFAULT_CONTENT,
}) => {
    return (
        <div className="bg-[#f2f2f2] pt-16 pb-16 md:py-0 lg:pt-0 lg:pb-2 xl:pt-4 xl:pb-4 2xl:pb-0">
            <div className="relative flex flex-col  bg-[#f2f2f2] md:max-w-[95%] lg:max-w-[90%] xl:max-w-[72%] 2xl:max-w-[72%] 5xl:max-w-[70%] mx-auto">
                <div className="flex flex-col-reverse md:flex-row lg:flex-col xl:flex-col md:h-[34vh] lg:h-[36vh] xl:h-[27vh] 2xl:h-[32vh]  ">
                    <div className="inset-y-0 top-0 left-0 w-full xl:px-0 mx-auto xl:pr-0 xl:mb-0 xl:mx-0 md:w-6/12 lg:w-6/12 xl:w-6/12  
                        2xl:w-6/12 3xl:w-6/12 5xl:w-7/12 md:max-w-full lg:max-w-full xl:max-w-full md:absolute lg:absolute xl:absolute">
                        <svg
                            className="absolute right-0 hidden h-full text-white transform translate-x-1/2 md:block lg:block xl:block"
                            viewBox="0 0 100 100"
                            fill="currentColor"
                            preserveAspectRatio="none slice"
                        >
                            <path d="M50 0H100L50 100H0L50 0Z" fill="#f2f2f2" />
                        </svg>
                        <img
                            loading="eager"
                            className="object-cover  2xl:object-[65%_35%]  w-full md:h-[32vh] lg:h-[34vh] xl:h-[25vh] 2xl:h-[30vh]  pt-10 md:pt-3 lg:pt-2 xl:pt-2 2xl:pt-0"
                            src={imageUrl}
                            alt={title}
                        />
                    </div>
                    <div className="relative flex items-center justify-center z-10 h-full px-4 ">
                        <div className="relative flex flex-row gap-8 md:justify-center md:items-center lg:justify-center lg:items-center xl:justify-center w-full  ">
                            <div className="hidden md:block lg:block lg:bg-transparent md:w-4/5  lg:w-1/2"></div>
                            <div className="w-full md:w-3/4 lg:w-1/2 xl:w-2/5 2xl:w-2/5 4xl:w-2/6 md:py-0 lg:py-0 xl:py-4 2xl:py-0  ">
                                <p className=" mb-4 md:mb-0 md:pt-2 lg:mb-1 lg:pt-5 xl:mb-2 xl:pt-6 2xl:pt-0 
                                    text-base md:text-sm lg:text-lg xl:text-xl font-semibold tracking-wider rounded-full inline-block  text-black uppercase ">
                                    {header}
                                </p>
                                <h2 className="mb-4 md:mb-1 md:pt-1 lg:mb-1 xl:mb-2  font-bold  tracking-tight text-black 
                                    text-2xl sm:text-4xl md:text-lg lg:text-2xl 2xl:text-4xl sm:leading-none ">
                                    {title} <span className="inline-block text-harvey-red">Our Expertise</span>
                                </h2>
                                <p className="pr-5 mb-4  text-base md:text-sm lg:text-lg xl:text-base 2xl:text-lg text-black max-w-3xl  "
                                    dangerouslySetInnerHTML={{ __html: content }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CTAWorkWithUs;